@if (
  {
    user: user$ | async,
    projectsMap: projectsMap$ | async,
    programsMap: programsMap$ | async,
    locationsMap: locationsMap$ | async,
    screenWidth: screenWidth$ | async,
    mainLoading: mainLoading$ | async,
    skedContext: skedContext$ | async,
    coinTypes: coinTypes$ | async,
    activeTasks: activeTasks$ | async,
    filteredTasks: filteredTasks$ | async
  };
  as state
) {
  <cs-shared-header
    [label]="
      state.skedContext?.type === 'project' ? state.projectsMap?.[state.skedContext?.projectId]?.label : 'My Sked'
    "
    [tabs]="filterButtons"
    [selectedTab]="state.skedContext?.filter"
    (backClick)="onBackClick()"
    (tabChange)="onChangeSkedContext(state.skedContext?.type, null, false, $any($event))"
  >
    <new-task-button
      slot="header-right"
      *userHasRoleOption="rolePermissionOptions.Tasks"
      [onFinishedNewTask]="onFinishedNewTask"
      [coinTypes]="state.coinTypes"
      [selectedProject]="
        state.skedContext?.type === 'project' ? state.projectsMap?.[state.skedContext?.projectId] : null
      "
    ></new-task-button>
  </cs-shared-header>

  @if (mainLoading$ | async) {
    <div class="loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else {
    <div class="tab-content-wrapper" [@tabContentSlide]="filterTabIndex">
      @if (filterTabIndex === 0) {
        <div class="sked-list-container">
          @if (state.activeTasks?.length > 0) {
            <current-sked-default-theme-active-task-list
              [tasks]="state.activeTasks"
              [projectsMap]="state.projectsMap"
              (taskClick)="onTaskClick($event)"
            ></current-sked-default-theme-active-task-list>
          }
          @for (task of state.filteredTasks; track task._id; let taskIndex = $index) {
            <current-sked-task
              [task]="task"
              [project]="state.projectsMap?.[task.projectId]"
              [expired]="false"
              (taskClick)="onTaskClick(task._id)"
            ></current-sked-task>
          }
          @if (!state.filteredTasks?.length) {
            <div class="empty-sked">No tasks to display</div>
          }
        </div>
      } @else {
        <div class="sked-list-container">
          @if (state.activeTasks?.length > 0) {
            <current-sked-default-theme-active-task-list
              [tasks]="state.activeTasks"
              [projectsMap]="state.projectsMap"
              (taskClick)="onTaskClick($event)"
            ></current-sked-default-theme-active-task-list>
          }
          @for (task of state.filteredTasks; track task._id; let taskIndex = $index) {
            <current-sked-task
              [task]="task"
              [project]="state.projectsMap?.[task.projectId]"
              [expired]="true"
              (taskClick)="onTaskClick(task._id)"
            ></current-sked-task>
          }
          @if (!state.filteredTasks?.length) {
            <div class="empty-sked">No tasks to display</div>
          }
        </div>
      }
    </div>
  }
}
